import React from 'react';
import PropTypes from 'prop-types';
import { tagsToHandlesAndLabels } from 'ck-utils/tags';

const PDPBreadcrumb = ({ tags }) => {
  const {
    gender,
    categoryHandle,
    categoryLabel,
    subCategoryHandle,
    subCategoryLabel,
  } = tagsToHandlesAndLabels(tags);
  const genderHandle = gender !== 'na' && gender;

  return (
    <ol>
      <li><a href="/">Home</a></li>
      {genderHandle && <li><a href={`/collections/${genderHandle}`}>{genderHandle}</a></li>}
      {categoryHandle && <li><a href={`/collections/${categoryHandle}`}>{categoryLabel}</a></li>}
      {subCategoryHandle && (
        <li>
          <a href={`/collections/${subCategoryHandle}`}>
            {subCategoryLabel}
          </a>
        </li>
      )}
    </ol>
  );
};

PDPBreadcrumb.propTypes = {
  tags: PropTypes.array.isRequired,
};

export { PDPBreadcrumb };
